const shop = {
  /**
   * 选择商城的label
   */
  filterText: 'Shops',
  filterText_1: 'Filter',
  /**
   * 选择商城的按钮
   */
  filterButton: 'Add',
  /**
   * 选择商城的label
   */
  timeRange: 'Time Frame',
  button: {
    searchViaUpload: 'Search via Upload',
    reset: 'Reset',
    submit: 'Submit',
    export: 'Download',
  },
  tableTitle: 'Promo Datails',
  table: {
    shopName: 'Shop Name',
    promoAmt: 'Promo Amt',
    promoBrandsAmt: 'No. of Promo Brands',
    detail: 'Detail',
    detailViewText: 'view',
  },
  tips: {
    noMall: 'No such shops',
  },
  modal: {
    queryShop: {
      title: 'Query by Shop',
    },
    brandInfo: {
      title: 'Brand Info',
      skuTable: {
        image: 'Image',
        code: 'Code',
        description: 'Description',
        brand: 'Brand',
      },
      table: {
        brand: 'Brand',
        total: 'Total',
        detail: 'Detail',
      },
    },
    shopInfo: {
      title: 'Shop Info',
      skuTable: {
        image: 'Image',
        code: 'Code',
        description: 'Description',
        brand: 'Brand',
      },
      table: {
        brand: 'Shop Name',
        total: 'SKU Total',
        detail: 'Detail',
      },
    },
  },
};
const brand = {
  /**
   * 选择商城的label
   */
  filterText: 'Brand',
  /**
   * 选择商城的按钮
   */
  filterButton: 'Add',
  /**
   * 选择商城的label
   */
  timeRange: 'Time Frame',
  button: {
    searchViaUpload: 'Search via Upload',
    reset: 'Reset',
    submit: 'Submit',
    export: 'Download',
  },
  tableTitle: 'Promo Datails',
  table: {
    brand: 'Brand',
    shopName: 'Shop Name',
    promoAmt: 'Promo Amt',
    promoMallAmt: 'Promo Shop Amt',
    detail: 'Detail',
    detailViewText: 'view',
  },
  modal: {
    selectBrandModal: {
      title: 'Select Brand',
    },
  },
};

export default {
  shop,
  brand,
};
